var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 32H24C10.746 32 0 42.742 0 56C0 69.254 10.746 80 24 80H32V400C32 444.125 67.875 480 112 480S192 444.125 192 400V80H200C213.254 80 224 69.254 224 56C224 42.742 213.254 32 200 32ZM144 256H80V80H144V256ZM488 32H312C298.746 32 288 42.742 288 56C288 69.254 298.746 80 312 80H320V400C320 444.125 355.875 480 400 480S480 444.125 480 400V80H488C501.254 80 512 69.254 512 56C512 42.742 501.254 32 488 32ZM432 256H368V80H432V256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVials);
export default __webpack_public_path__ + "static/media/vials.5ab8d6510748ed98910eec1fc1904751.svg";
export { ForwardRef as ReactComponent };